import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { useSettings } from '@/context/SettingsContext';

const CONSENT_KEY = 'gb_sylt_cookie_consent';

export const CookieBanner = () => {
  const [visible, setVisible] = useState(false);
  const { settings: s, settingsLoaded } = useSettings();
  const location = useLocation();

  useEffect(() => {
    const consent = localStorage.getItem(CONSENT_KEY);
    if (!consent && settingsLoaded) {
      setVisible(true);
    }
  }, [settingsLoaded]);

  const handleAccept = () => {
    localStorage.setItem(CONSENT_KEY, 'accepted');
    setVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem(CONSENT_KEY, 'declined');
    setVisible(false);
  };

  // Hide cookie banner on supplier release page
  if (!visible || location.pathname.startsWith('/lieferanten-freigabe')) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[100] bg-white border-t border-slate-200 shadow-lg" data-testid="cookie-banner">
      <div className="max-w-5xl mx-auto px-4 py-4 sm:py-5 flex flex-col sm:flex-row items-start sm:items-center gap-4">
        <div className="flex-1 text-sm text-slate-600 leading-relaxed">
          <p>
            {s.cookie_banner_text || ''}{' '}
            <Link to="/datenschutz" className="text-[#0E518D] underline hover:text-[#0B4171]" data-testid="cookie-privacy-link">
              Datenschutzerklärung
            </Link>
          </p>
        </div>
        <div className="flex items-center gap-3 shrink-0">
          <Button
            variant="outline"
            size="sm"
            onClick={handleDecline}
            className="rounded-sm text-xs uppercase tracking-wide"
            data-testid="cookie-decline-btn"
          >
            Ablehnen
          </Button>
          <Button
            size="sm"
            onClick={handleAccept}
            className="bg-[#0E518D] hover:bg-[#0B4171] text-white rounded-sm text-xs uppercase tracking-wide"
            data-testid="cookie-accept-btn"
          >
            Akzeptieren
          </Button>
        </div>
      </div>
    </div>
  );
};
